import { render, staticRenderFns } from "./AddInsurance.vue?vue&type=template&id=0ef29c54&scoped=true"
import script from "./AddInsurance.vue?vue&type=script&lang=js"
export * from "./AddInsurance.vue?vue&type=script&lang=js"
import style0 from "./AddInsurance.vue?vue&type=style&index=0&id=0ef29c54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef29c54",
  null
  
)

export default component.exports